import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditContinents from './EditContinents'
import ListContinents from './ListContinents'
import NewContinents from './NewContinents'

const AdminContinentsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListContinents /></PrivateRoute7>} />
        <Route path="edit-continent" element={<PrivateRoute7><EditContinents /></PrivateRoute7>} />
        <Route path="new-continent" element={<PrivateRoute7><NewContinents /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminContinentsRoutes